import { Input } from 'antd'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'

import styles from './SimpleSearch.module.css'

export default function SimpleSearch() {
  const router = useRouter()
  const changeRoute = (obj: Record<string, number | string>) => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...obj,
        },
      },
      undefined,
      { shallow: true, scroll: true }
    )
  }
  const keywords = String(router.query.keywords || '')
  const [text, setText] = useState('')

  const handleEnter = () => changeRoute({ keywords: text })

  useEffect(() => {
    setText(keywords)
  }, [keywords])

  return (
    <div className="w-[167px]">
      <Input
        className={styles.customInput}
        placeholder="搜描述词 找AI创作"
        suffix={<MyIcon icon="search" className="text-neutral-400" />}
        value={text}
        onChange={e => {
          setText(e.target.value)
        }}
        onPressEnter={handleEnter}
      />
    </div>
  )
}
